import React from 'react';
import RegisterForm from '../components/auth/RegisterForm';

const RegisterPage: React.FC = () => {
  return (
    <div className="auth-page">
      <RegisterForm />
    </div>
  );
};

export default RegisterPage;
